import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { translation } from '../../../../utils/helpers'

// Elements
import Col from '../../../../shared/elements/col'
import Check from '../../../../shared/elements/check'
import Inline from '../../../../shared/elements/inline'
import Icon from '../../../../shared/elements/icon'
import Grid from '../../../../shared/elements/grid'

import { OrderDepartmentIcons } from '../../../../shared/elements/icons'

class InspectionHeader extends PureComponent {

  constructor (props) {
    super(props)
    this.state = {
    }
    this.renderDepartmentType = this.renderDepartmentType.bind(this)
  }

  componentDidMount () {
  }
  componentWillUnmount () {
  }

  renderDepartmentType () {
    let paintActive = ''
    let bodyActive = ''
    // let paintImage = 'blue'
    // let bodyImage = 'blue'
    // let paintActive = ''
    // let bodyActive = ''

    if (this.props.hasPaintWork) {
      // paintImage = 'white1'
      paintActive = 'active'
    }
    if (this.props.hasBodyWork) {
      // bodyImage = 'white'
      bodyActive = 'active'
    }
    const togglePaint = () => {
      this.props.togglePaint()
    }
    const toggleBody = () => {
      this.props.toggleBody()
    }
    // let paintIcon = (
    //   <Icon icon={OrderDepartmentIcons.Paint} />
    // )
    // let bodyIcon = (
    //   <Icon icon={OrderDepartmentIcons.Body} />
    // )
    return (
      <Grid>
        <div className={paintActive + ' paint'}>
          <Inline block alignChildren={'center'}>
            <Check simple checked={this.props.hasPaintWork} onClick={togglePaint} onChange={() => { }} />
            <Icon icon={OrderDepartmentIcons.Paint} />
          </Inline>
        </div>
        <div className={bodyActive + ' body'}>
          <Inline block alignChildren={'center'}>
            <Check simple checked={this.props.hasBodyWork} onClick={toggleBody} onChange={() => { }} />
            <Icon icon={OrderDepartmentIcons.Body} />
          </Inline>
        </div>
      </Grid>
    )
  }
  render () {
    if (this.props.auth.departmentType === 0) return null
    // let commonClass = 'common'
    // let extraClass = ' body'
    // let rightClass = 'rightheader'
    // if (this.props.auth.departmentType === 1) {
      // commonClass += extraClass
      // rightClass += extraClass
    // }
    return (
      <div className='orderinspection_header'>
        <Col>
          <div className='common'>
            {this.props.auth.departmentType === 2 && this.renderDepartmentType()}
          </div>
        </Col>
        {this.props.hasBodyWork && (<Col>
          <Inline alignChildren={'center'}>
            <Icon icon={OrderDepartmentIcons.Body} alt={translation('14779')} />
            <h2>{translation('14779')}</h2>
          </Inline>
        </Col>)}
        {this.props.hasPaintWork && (<Col>
          <Inline alignChildren={'center'}>
            <Icon icon={OrderDepartmentIcons.Paint} alt={translation('161')} />
            <h2>{translation('161')}</h2>
          </Inline>
        </Col>)}
      </div>
    )
  }
}
InspectionHeader.defaultProps = {
  hasBodyWork: true,
  hasPaintWork: true,
  toggleBody: (e) => { console.log('clicked body') },
  togglePaint: (e) => { console.log('clicked paint') }
}
InspectionHeader.propTypes = {
  toggleBody: PropTypes.func,
  togglePaint: PropTypes.func,
  hasBodyWork: PropTypes.bool,
  hasPaintWork: PropTypes.bool
}
InspectionHeader.contextTypes = {
  router: PropTypes.object.isRequired
  // t: React.PropTypes.func.isRequired,
  // enum: React.PropTypes.func.isRequired
}
function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
})(InspectionHeader)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderInspection/InspectionHeader/index.js